<div class="layout-container">
    <h2 class="heading-lg">List of Clients</h2><hr>
<P class="text-block">
    We cater to Pioneers of Automotive, Electronics, Electrical, Food & Beverages, Pharmaceutical & Household industry. 
    Partial list of our reputed clients are: 
</P>

<div class="gallery-wrapper">
    <div class="image-gallery">
        <div class="image-item" *ngFor="let imag of clientImages">
            <app-image-gallery [images]="imag"></app-image-gallery>
          </div>
    </div>
</div>
</div>

